export default __webpack_public_path__ + "static/media/FISIOTERAPIA.b522cec2.pdf";